
// export interface Booking {
//   "id": 34268,
//   "resource": 2292,
//   "member": 229048,
//   "fromDateTime": "2021-06-18T11:00",
//   "untilDateTime": "2021-06-18T12:00",
//   "state": "confirmed",
//   "lockVersion": 1,
//   "createdAt": "2021-06-18T17:54:34.118Z",
//   "updatedAt": "2021-06-18T17:54:34.118Z",
//   "updatedBy": 229046,
//   "account": 1468
// }
export interface Color {
  b: number;
  g: number;
  r: number;
}
export interface WorkshopObj {
  id: string;
  resourceId: string;
  title: string;
  description: string;
  link?: string;
  startDateTime: Date;
  untilDateTime: Date;
  maxAttendees: number;
  // guests: GuestObj[],
  imageSrc?: string;
  eventType: EVENT_TYPE;
  bookings?: WorkshopBookingObj[];
  // category?: WorkshopCategoryObj;
  fabmanCourseId?: number;
}

export interface WorkshopCategoryObj {
  id: string;
  name: string;
}

export interface MachineObj {
  id: string;
  resourceId: number; //from Fabman
  fabmanResource: any;
  requiredWorkshops: string[];
  requiredWorkshopCategories: WorkshopCategoryObj[];


}

export interface WorkshopBookingObj {
  id: string;
  userId: string;
  workshopId: string;
  userEmail? : string;
  userName?: string;
  certified?: boolean;
}

export interface MachineBookingObj{
  id?: string;
  fabmanBookingObj: FabmanBookingObj;
  userId?: string;
}

export interface FabmanBookingObj {
  // id: number,
  resource: number,
  member: number,
  fromDateTime: string,
  untilDateTime: string,
  state: string,
  ignoreMemberRestrictions: boolean
}
// export interface BookingObj {
//   id: string;
//   userId: string;
//   resourceId: number;
// }

export interface GuestObj {
  name: string;
  role: string;
  email: string;
  // workshopId: string;
  // inviteStatus?: InviteStatus;
}


export enum EVENT_TYPE { WORKSHOP = 'WORKSHOP'}
export enum BOOKING_TYPE { WORKSHOP , MACHINE }

export enum CALENDAR_TYPE { WORKSHOPS = 0, MACHINES = 1}